import beauthBrowser from '@/lib/beauth/beauth.browser';
import { sessionClosed } from '@/store/auth/auth.slice';
import { dashboardApi } from '@/store/api/base/api.base';
import type { TypeAppDispatch } from '@/store/store';

export default function sessionWatch(dispatch: TypeAppDispatch): () => void {
    return beauthBrowser.subscribe((state) => {
        if (state.access !== null || state.reason === null) return;
        dispatch(sessionClosed());
        dispatch(dashboardApi.util.resetApiState());
    });
}
